// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-loader{position:fixed;top:0;left:0;right:0;height:100vh;z-index:1000;background:transparent;margin:0 auto;text-align:center;width:100%;min-height:100%;opacity:1}.page-loader *{-webkit-animation-play-state:running;animation-play-state:running}@-webkit-keyframes loader-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loader-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
